function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.277344,
  y: 312.578,
  width: 534.67,
  height: 525.079,
  fill: "url(#mission_can_left0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M453.218 312.568C453.192 358.271 439.354 402.9 413.52 440.602C387.686 478.303 351.06 507.317 308.448 523.838V539.068H226.748C101.668 539.068 0.277517 437.648 0.277517 312.578C0.240676 282.825 6.07306 253.358 17.4407 225.862C28.8083 198.367 45.488 173.383 66.5245 152.343C87.561 131.303 112.541 114.619 140.035 103.246C167.528 91.874 196.995 86.0364 226.748 86.068H308.448V101.268C351.099 117.741 387.761 146.746 413.604 184.465C439.446 222.184 453.257 266.846 453.218 312.568Z",
  fill: "url(#mission_can_left1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M108.017 219.798C110.457 258.898 107.737 289.688 103.567 312.568C97.3975 346.488 88.0675 363.048 87.7475 363.568C87.7475 363.568 54.1775 351.788 37.2775 312.568C24.7675 283.648 21.2775 239.808 47.0375 174.808C76.1554 136.807 116.555 108.999 162.447 95.3679C136.617 121.578 109.447 160.188 107.837 207.428C107.697 211.488 107.757 215.611 108.017 219.798Z",
  fill: "#526293"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M534.948 312.568C534.901 368.17 514.406 421.812 477.366 463.281C440.327 504.75 389.329 531.147 334.085 537.448C278.842 543.748 223.21 529.51 177.785 497.446C132.359 465.382 100.313 417.731 87.7476 363.568C75.5591 310.784 82.6828 255.381 107.828 207.398C131.347 162.538 169.224 126.856 215.406 106.052C261.589 85.2489 313.411 80.5249 362.594 92.6352C411.776 104.745 455.481 132.991 486.724 172.859C517.967 212.727 534.946 261.916 534.948 312.568Z",
  fill: "url(#mission_can_left2)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M87.7476 363.608C75.5941 310.823 82.7162 255.432 107.828 207.438L308.448 312.578L87.7476 363.608Z",
  fill: "#485982"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M534.948 312.568H0.277505C0.24198 282.816 6.07534 253.349 17.4436 225.855C28.8118 198.361 45.4916 173.379 66.528 152.34C87.5643 131.3 112.544 114.617 140.037 103.245C167.53 91.8735 196.996 86.0363 226.748 86.0679H304.188C334.286 85.5125 364.193 90.9603 392.162 102.093C420.131 113.226 445.601 129.82 467.084 150.907C488.568 171.994 505.634 197.151 517.286 224.908C528.938 252.664 534.942 282.465 534.948 312.568Z",
  fill: "#7491C4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M492.947 0.540039H123.947V312.578H492.947V0.540039Z",
  fill: "url(#mission_can_left3)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M492.948 312.568C492.948 414.458 410.348 497.068 308.448 497.068C206.548 497.068 123.948 414.458 123.948 312.568C123.948 210.668 206.548 128.068 308.448 128.068C410.348 128.068 492.938 210.668 492.948 312.568Z",
  fill: "#3C4466"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M492.948 312.568H123.948C123.948 210.668 206.548 128.068 308.448 128.068C410.348 128.068 492.938 210.668 492.948 312.568Z",
  fill: "#7491C4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M308.448 487.588C405.109 487.588 483.468 409.229 483.468 312.568C483.468 215.907 405.109 137.548 308.448 137.548C211.787 137.548 133.428 215.907 133.428 312.568C133.428 409.229 211.787 487.588 308.448 487.588Z",
  fill: "url(#mission_can_left4)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M308.447 468.488C394.56 468.488 464.367 398.68 464.367 312.568C464.367 226.456 394.56 156.648 308.447 156.648C222.335 156.648 152.527 226.456 152.527 312.568C152.527 398.68 222.335 468.488 308.447 468.488Z",
  fill: "url(#mission_can_left5)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M241.438 237.838H227.878C201.224 237.838 179.618 259.445 179.618 286.098V339.048C179.618 365.701 201.224 387.308 227.878 387.308H241.438C268.091 387.308 289.698 365.701 289.698 339.048V286.098C289.698 259.445 268.091 237.838 241.438 237.838Z",
  stroke: "#120E26",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M418.457 262.668L300.727 269.348C295.912 269.619 291.384 271.723 288.071 275.229C284.759 278.734 282.915 283.375 282.917 288.198V336.948C282.915 341.771 284.759 346.411 288.071 349.917C291.384 353.423 295.912 355.527 300.727 355.798L418.457 362.478C421.023 362.624 423.591 362.244 426.004 361.362C428.418 360.481 430.626 359.116 432.494 357.351C434.362 355.587 435.849 353.459 436.866 351.1C437.883 348.74 438.408 346.197 438.407 343.628V281.518C438.406 278.949 437.881 276.407 436.863 274.048C435.846 271.689 434.358 269.562 432.491 267.798C430.623 266.033 428.416 264.668 426.003 263.786C423.59 262.904 421.022 262.524 418.457 262.668ZM352.457 328.018C352.457 330.331 352.002 332.62 351.117 334.757C350.232 336.894 348.935 338.835 347.3 340.47C345.664 342.105 343.723 343.402 341.587 344.287C339.45 345.172 337.16 345.628 334.847 345.628H321.417C316.756 345.628 312.284 343.779 308.983 340.488C305.682 337.196 303.821 332.73 303.807 328.068V297.128C303.807 292.457 305.663 287.978 308.965 284.676C312.268 281.373 316.747 279.518 321.417 279.518H334.877C339.548 279.518 344.027 281.373 347.33 284.676C350.632 287.978 352.487 292.457 352.487 297.128L352.457 328.018ZM421.277 340.938C421.277 343.346 420.321 345.656 418.618 347.358C416.915 349.061 414.606 350.018 412.197 350.018H381.697C379.289 350.018 376.98 349.061 375.277 347.358C373.574 345.656 372.617 343.346 372.617 340.938V288.598C372.617 286.19 373.574 283.88 375.277 282.177C376.98 280.475 379.289 279.518 381.697 279.518H412.217C414.626 279.518 416.935 280.475 418.638 282.177C420.341 283.88 421.297 286.19 421.297 288.598L421.277 340.938Z",
  fill: "#223B72"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M282.918 295.308C282.918 268.655 261.313 247.048 234.663 247.048C208.012 247.048 186.408 268.655 186.408 295.308V329.838C186.408 356.491 208.012 378.098 234.663 378.098C261.313 378.098 282.918 356.491 282.918 329.838V295.308Z",
  fill: "#120E26"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M438.407 281.518V312.568H421.277V288.568C421.277 286.16 420.321 283.85 418.618 282.147C416.915 280.445 414.606 279.488 412.197 279.488H381.697C379.289 279.488 376.98 280.445 375.277 282.147C373.574 283.85 372.617 286.16 372.617 288.568V312.568H352.487V297.128C352.487 292.457 350.632 287.978 347.33 284.676C344.027 281.373 339.548 279.518 334.877 279.518H321.417C316.747 279.518 312.268 281.373 308.965 284.676C305.663 287.978 303.807 292.457 303.807 297.128V312.568H282.917V288.198C282.915 283.375 284.759 278.734 288.071 275.229C291.384 271.723 295.912 269.619 300.727 269.348L418.457 262.668C421.022 262.524 423.59 262.904 426.003 263.786C428.416 264.668 430.623 266.033 432.491 267.798C434.358 269.562 435.846 271.689 436.863 274.048C437.881 276.407 438.406 278.949 438.407 281.518Z",
  fill: "#7491C4"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M438.407 213.008H282.917V384.578H438.407V213.008Z",
  fill: "url(#mission_can_left6)"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left0",
  x1: 267.612,
  y1: 312.578,
  x2: 267.612,
  y2: 837.657,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.294748,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.963974,
  stopColor: "#120E26",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left1",
  x1: 113.498,
  y1: 508.728,
  x2: 345.238,
  y2: 107.338,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00722638,
  stopColor: "#403286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.242918,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#24335B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#22396C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left2",
  x1: 81.9376,
  y1: 312.568,
  x2: 531.848,
  y2: 312.568,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#24335B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#22396C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left3",
  x1: 308.777,
  y1: 10.4191,
  x2: 307.486,
  y2: 309.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7491C4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#7491C4",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#7491C4",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#7491C4",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#7491C4",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#7491C4",
  stopOpacity: 0.67
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#7491C4",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left4",
  x1: 483.478,
  y1: 312.568,
  x2: 133.428,
  y2: 312.568,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#232E55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#1F224C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1542"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left5",
  x1: 379.507,
  y1: 456.988,
  x2: 241.817,
  y2: 177.128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#233868"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#223A6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_left6",
  x1: 360.907,
  y1: 218.628,
  x2: 360.397,
  y2: 382.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7491C4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#7491C4",
  stopOpacity: 0.24
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#7491C4",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#7491C4",
  stopOpacity: 0.64
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#7491C4",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7491C4",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7491C4",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#7491C4",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#7491C4",
  stopOpacity: 0.04
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7491C4",
  stopOpacity: 0
})));

function SvgCanLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 535 838",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanLeft);
export default __webpack_public_path__ + "static/media/can-left.62748f79.svg";
export { ForwardRef as ReactComponent };